"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = exports.CloudinaryImage = exports.Data = exports.Widget = exports.ParameterValue = exports.Gallery = exports.Comment = exports.SinglePostModel = exports.PostCategory = exports.Post = exports.PostAuthor = exports.PagingResult = exports.DataResult = exports.EntityBase = void 0;
class EntityBase {
}
exports.EntityBase = EntityBase;
class DataResult {
    constructor() {
        this.results = [];
    }
}
exports.DataResult = DataResult;
class PagingResult extends DataResult {
    constructor() {
        super();
    }
}
exports.PagingResult = PagingResult;
class PostAuthor extends EntityBase {
    constructor() {
        super();
        this.name = {};
    }
}
exports.PostAuthor = PostAuthor;
class Post extends EntityBase {
    constructor() {
        super();
        this.author = new PostAuthor();
    }
}
exports.Post = Post;
class PostCategory extends EntityBase {
}
exports.PostCategory = PostCategory;
class SinglePostModel extends Post {
    constructor() {
        super();
        this.textBrief = 'loading';
        this.comments = [];
    }
}
exports.SinglePostModel = SinglePostModel;
class Comment extends EntityBase {
}
exports.Comment = Comment;
class Gallery extends EntityBase {
}
exports.Gallery = Gallery;
class ParameterValue extends EntityBase {
}
exports.ParameterValue = ParameterValue;
class Widget extends EntityBase {
}
exports.Widget = Widget;
class Data {
    constructor(parameters, widgets) {
        this.parameters = parameters;
        this.widgets = widgets;
    }
}
exports.Data = Data;
/* tslint:disable:variable-name */
class CloudinaryImage {
}
exports.CloudinaryImage = CloudinaryImage;
class Error {
}
exports.Error = Error;
/* tslint:enable:variable-name */
